<template>
  <div class="expert-chart-frame" :class="{'expert-chart-inline': inline}">
    <div v-if="$route.name.includes('hyundai') || $route.name.includes('dlcon')" style="height:12px;content:'';display: block"></div>
    <bjd-code-select-component
        v-if="getBjdLevel() !== 'none'"
        select-button="true"
        :on-click-select="refresh"
        :use-sise="getUseSise()"
        :bjd-level="getBjdLevel()"
    />
    <v-row
      align="center"
      justify="center"
    >
      <div
        v-if="!inline"
        class="wrapper"
        ref="wrapper"
        v-on:scroll="handleScrollWrapper"
        :style="{
          'width': '100%',
          'overflow-x': this.wrapperVisible ? 'auto' : 'hidden',
          'overflow-y': 'hidden',
          'position': 'fixed',
          'bottom': '0'
          }"
      >
        <div class="div1">
        </div>
      </div>
      <div
        :id="inline ? null : 'tableauEmbed'"
        ref="tableauEmbed"
        class="pa-0 ma-0 tableau-embed"
        v-on:scroll="handleScrollTableau"
        >
      </div>
    </v-row>

    <v-dialog
      v-if="!inline"
      v-model="paymentRequiredDialog"
      max-width="300"
      persistent
    >
    <!-- goTo="/service/realestate" -->
      <payment-required
        goTo="/pricing"
      ></payment-required>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { api } from '../mixins/api.js'
import PaymentRequired from './payment/PaymentRequired'
import BjdCodeSelectComponent from "@/components/b2b/BjdCodeSelectComponent.vue";

const tableauServer_url = "https://prod-kr-a.online.tableau.com/t/mas";

export default {
  async created() {
    if (this.tableauId === '') {
      alert('잘못된 접근입니다. (code-1)')
      this.$router.push('/pageNotFound');
      return;
    }
    await this.initViz();
    if (this.vizDisposed || this.inline) return;
    window.removeEventListener('scroll', this.handleScroll)
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    this.vizDisposed = true;
    this.vizRequestId += 1;
    this._pendingVizTicket = null;
    this.detachInlineViz();
    window.removeEventListener('scroll', this.handleScroll);
  },
  props: {
    inline: { type: Boolean, default: false },
    tableauId: {
      type: String,
      defualt: '',
    },
    isCorpTableau: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    tableauId: {
      handler: function() {
        this.showDrawer(false);
        this.initViz();
      }
    }
  },
  computed: {
    ...mapState([
      "paymentRequiredDialog",
      "profile",
      "bjdInfo",
        "priceType"
    ]),
  },
  data() {
    return {
      vizId: '',
      vizRequestId: 0,
      vizDisposed: false,
      wrapperVisible: true,
      notUseSiseList: [
        'real_richgo_ai_price_region/region_several_price_trend_01',
      ],
      sdList: [
        'real_region_summary1_richgo/sd_01'
      ],
      sggList: [
        'real_region_summary2_richgo/sgg_01',
        'checklist1_sdsggdanji01/checklist_heatmap01',
        'female_20to40/female_20to40_01',
        'real_richgo_ai_price_region/region_several_price_trend_01',
        'real_danji/price_rank_02',
        'realestate_registration/realestate_registration_01',
      ],
      emdList: [
        'population_in_lifezone/population_in_lifezone_01',
        'income_in_lifezone/income_in_lifezone_01',
        'households_in_lifezone/households_in_lifezone_01',
        'real_richgo_ai_price_region/richgo_region_price_01',
        'real_richgo_ai_price_danji/richgo_danji_price_01',
        'real_price_stat_item/real_price_stat_item_01'
      ]
    }
  },
  methods: {
    ...mapMutations([
      'showPaymentRequiredDialog', 'showDrawer'
    ]),
    async refresh() {
      if (this.tableauId === '') {
        alert('잘못된 접근입니다. (code-1)')
        this.$router.push('/pageNotFound');
        return;
      }
      await this.initViz();
      if (this.vizDisposed || this.inline) return;
      window.removeEventListener('scroll', this.handleScroll)
      window.addEventListener('scroll', this.handleScroll);
    },
    getUseSise() {
      return this.getBjdLevel() !== 'none' && !this.notUseSiseList.includes(this.tableauId);
    },
    getBjdLevel() {
      if (this.sdList.includes(this.tableauId))
        return 'sd';

      if (this.sggList.includes(this.tableauId))
        return 'sgg';

      if (this.emdList.includes(this.tableauId))
        return 'emd';

      return 'none';
    },
    setWarapperScrollVisible(v) {
      if (this.wrapperVisible !== v) {
        this.wrapperVisible = v;
        if (v === true) {
          this.$refs.wrapper.scrollLeft = this.$refs.tableauEmbed.scrollLeft;
        }
      }
    },
    handleScroll(event) {
      // footer 사이즈 하드코딩
      if (event.target.body.scrollHeight - window.scrollY - window.innerHeight < 140) {
        this.setWarapperScrollVisible(false);
      } else {
        this.setWarapperScrollVisible(true);
      }
    },
    handleScrollWrapper(event) {
      this.$refs.tableauEmbed.scrollLeft = event.target.scrollLeft;
    },
    handleScrollTableau(event) {
      if (this.$refs.wrapper) this.$refs.wrapper.scrollLeft = event.target.scrollLeft;
    },
    notifyChartState(state, view) {
      this.$emit('chart-state', { view, state });
      if (this.$el && typeof this.$el.dispatchEvent === 'function') {
        this.$el.dispatchEvent(new CustomEvent('expert-chart-load', {
          bubbles: true,
          detail: { view, state }
        }));
      }
    },
    detachInlineViz() {
      if (!this._inlineViz) return;
      const { element, ready, error } = this._inlineViz;
      element.removeEventListener('firstinteractive', ready);
      element.removeEventListener('vizloaderror', error);
      this._inlineViz = null;
    },
    observeInlineViz(element, requestId, view) {
      if (!this.inline) return;
      this.detachInlineViz();
      const current = () => !this.vizDisposed && requestId === this.vizRequestId && view === this.tableauId;
      const ready = () => { if (current()) this.notifyChartState('ready', view); };
      const error = () => { if (current()) this.notifyChartState('error', view); };
      this._inlineViz = { element, ready, error };
      element.addEventListener('firstinteractive', ready);
      element.addEventListener('vizloaderror', error);
    },
    async requestVizTicket(requestedTableauId) {
      const auth = this.$store && this.$store.state || {};
      // Share only an unfinished request from this instance and authentication context.
      // Keep identity values in memory; never cache or publish a completed ticket.
      const identity = [requestedTableauId, this.profile, this.profile && this.profile.userId,
        this.profile && this.profile.isCorp, auth.accessToken, auth.refreshToken,
        auth.isLoggedin, auth.authorityLevel];
      const pending = this._pendingVizTicket;
      if (pending && pending.identity.every((value, index) => value === identity[index])) return pending.promise;
      const request = {
        identity,
        promise: api.methods.getTableauTicketApi(requestedTableauId, this.profile && this.profile.isCorp)
      };
      this._pendingVizTicket = request;
      try {
        return await request.promise;
      } finally {
        if (this._pendingVizTicket === request) this._pendingVizTicket = null;
      }
    },
    async initViz() {   
      if (this.vizDisposed) return;
      const requestId = ++this.vizRequestId;
      const requestedTableauId = this.tableauId;
      const currentViz = document.getElementById(this.vizId);
      if (currentViz && currentViz.getAttribute('src') !== `${tableauServer_url}/views/${requestedTableauId}`) {
        this.detachInlineViz();
        currentViz.remove();
      }
      this.notifyChartState('loading', requestedTableauId);
      let response;
      try {
        response = await this.requestVizTicket(requestedTableauId);
      } catch (_) {
        if (!this.vizDisposed && requestId === this.vizRequestId && requestedTableauId === this.tableauId) this.notifyChartState('error', requestedTableauId);
        return;
      }
      // Ignore a previous selection or an answer received after this view was closed.
      if (this.vizDisposed || requestId !== this.vizRequestId || requestedTableauId !== this.tableauId) return;
      if (response === null || response === undefined) {
        this.notifyChartState('error', requestedTableauId);
        return;
      } else {

        const { isAllowed, ticket } = response;
        if (isAllowed) {
          const container = this.$refs.tableauEmbed;
          if (!container) {
            this.notifyChartState('error', requestedTableauId);
            return;
          }
          
          const beforeViz = document.getElementById(this.vizId)
          this.detachInlineViz();
          if(beforeViz) beforeViz.remove();

          this.vizId = `tableau-viz-${this._uid}-${requestId}`;

          let url = `${tableauServer_url}/views/${this.tableauId}`;

          let refreshUrlList = [
'hedc_site_search_01/hdec_site_search_01_main_01',
'hedc_site_parcelout_danji_price_analysis_01/hedc_site_parcelout_danji_price_analysis_01_main_01',
'hedc_site_parcelout_danji_price_analysis_02/hedc_site_parcelout_danji_price_analysis_01_main_02',
'hedc_site_parcelout_danji_price_analysis_03/hedc_site_parcelout_danji_price_analysis_01_main_03',
'hedc_site_parcelout_danji_price_analysis_04/hedc_site_parcelout_danji_price_analysis_01_main_04',
'hedc_site_parcelout_danji_price_analysis_05/hedc_site_parcelout_danji_price_analysis_01_main_05',
'hedc_site_demand_target_01/hedc_site_demand_target_01_main_01',
'b2b_market_trend_parcelout_danji_price_01/b2b_market_trend_parcelout_danji_price_01_main_01',
'b2b_market_trend_parcelout_danji_price_01/b2b_market_trend_parcelout_danji_price_01_main_02',
'hdec_government_regulation_01/hdec_government_regulation_01_main_02'
];

          const querys = {};
          if (refreshUrlList.includes(this.tableauId)) {
            // 예전에 데이터 최신화된 걸로 가져오기 위해 썼는데
            // viz-params에 넣어도 쿼리파라미터로 붙여주긴 하는듯. 일단 추가.
            querys[':refresh'] ='y';
          }

          if (this.bjdInfo) {
            let filterEnable = false;
            let count = 10;
            if (this.sdList.includes(this.tableauId)){
              count = 2;
              filterEnable = true;
            } else if (this.sggList.includes(this.tableauId)) {
              count = 5;
              filterEnable = true;
            } else if (this.emdList.includes(this.tableauId)) {
              count = 10;
              filterEnable = true;
            } else if (this.isCorpTableau === false) {
              // 현대 건설 버전 (미사용 될 가능성 높음)              
              querys['sd'] = this.bjdInfo.sd || '';
              querys['sgg'] = this.bjdInfo.sgg || '';
              querys['emd'] = this.bjdInfo.emd || '';
            }

            if (filterEnable) {
              if (this.bjdInfo.bjdCode)
                querys['bjdCode'] = this.bjdInfo.bjdCode.slice(0, count) + "0".repeat(this.bjdInfo.bjdCode.length - count);

              if (this.priceType)
                querys['dataSource']  = this.priceType;
            }
          }

          // 1800 * 1000 고정 사이즈
          const vizElement = document.createElement("tableau-viz");
          vizElement.id = this.vizId;

          Object.entries(querys)
            .filter(([, value]) => value !== null && value !== undefined)
            .forEach(([key, value]) => {
              const vizParamElement = document.createElement('viz-parameter');
              vizParamElement.setAttribute('name', key);
              vizParamElement.setAttribute('value', value);
              vizElement.appendChild(vizParamElement);
            });

          vizElement.setAttribute("src", url);
          vizElement.setAttribute("toolbar", "hidden");
          vizElement.setAttribute("hideTabs", "true");

          vizElement.setAttribute("token", ticket);

          if (this.inline) {
            vizElement.setAttribute('width', '100%');
            vizElement.setAttribute('height', '1000');
            const area = this.bjdInfo || {};
            this.$emit('chart-context', { view: requestedTableauId, signature: JSON.stringify([area.bjdCode || '', area.sd || '', area.sgg || '', area.emd || '', this.priceType || '']), usesSharedRegion: this.getBjdLevel() !== 'none' || this.isCorpTableau === false });
          }
          this.observeInlineViz(vizElement, requestId, requestedTableauId);
          container.appendChild(vizElement);
        } else {

          if (this.inline) {
            this.detachInlineViz();
            const deniedViz = document.getElementById(this.vizId);
            if (deniedViz) deniedViz.remove();
          }
          this.notifyChartState('permission', requestedTableauId);
          if (!this.inline) this.showPaymentRequiredDialog(true);
        }
      }
    },
  },
  components: {
    BjdCodeSelectComponent,
    PaymentRequired
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: fixed;
  bottom: 0;
}

.div1 {
  width: 1800px;
  height: 20px;
}


.tableau-embed {
  overflow-x: auto;
}
.expert-chart-inline { min-width: 0; width: 100%; }
.expert-chart-inline > .row { margin: 0; }
.expert-chart-inline .tableau-embed { width: 100%; min-height: 600px; }
</style>
